<script>

    import { TicketStore } from '../stores'

    import MenuMain from '../$layouts/menu.main.svelte'

    import Tickets from '../tickets/tickets.svelte'
    import TicketRead from '../tickets/ticket.svelte'
    import TicketUpdate from '../tickets/ticket.update.svelte'
    import TicketDocument from '../tickets/ticket.document.svelte'
    
    import Modal from '../$components/modal.svelte'

</script>

<MenuMain />

<div class="container">
    <Tickets />
</div>

<Modal id="TicketRead" title="Información">
    <TicketRead />
</Modal>

<Modal id="TicketUpdate" title="Actualizar ticket">
    <TicketUpdate on:updated={() => TicketStore.modalRead()} on:canceled={() => TicketStore.modalRead()} />
</Modal>

<Modal id="TicketDocument" title="Actualizar factura">
    <TicketDocument label="Factura" fieldName="factura" on:updated={TicketStore.modalClose} on:canceled={() => TicketStore.modalRead()} />
</Modal>